<svg viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.66968 0.999999L2.66968 11" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.33333 9.33333L2.66667 11L1 9.33333" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
